import { withStyles, TextField, Button, Icon, Box, SubTitle, PartnerLogin, BodyText } from 'vopay';
import { useState, useEffect } from 'react';
import { Formik } from 'formik';
import styles from './Login.module.scss';
import TwoFactorAuthenticationContainer from './TwoFactorAuthentication/TwoFactorAuthenticationContainer';
import { usePartnerLogin } from '@/providers/PartnerLogin.provider';
import MSEntraButton, { type LoginResult } from './MSEntraButton/MsEntraButton';
import { Title } from 'UI';

const cn = withStyles(styles);

const LoginForm = () => {
  const { isSubmitting, login, response, storeLogin } = usePartnerLogin();
  const [usingMsEntra, setUsingMsEntra] = useState(false);
  const [shouldShowLoginPage, setShouldShowLoginPage] = useState(true);
  const [shouldShow2FA, setShouldShow2FA] = useState(false);
  const [loginRequest, setLoginRequest] = useState({
    Username: '',
    Password: '',
  });

  const handlePartnerLogin = (values: PartnerLogin) => {
    setLoginRequest({
      Username: values.username || '',
      Password: values.password || '',
    });

    login({
      username: values.username || '',
      password: values.password || '',
    });
  };

  const TwoFAEnabled = import.meta.env.VITE_2FA_Enabled === 'true';

  useEffect(() => {
    if (response.success !== undefined) {
      if (
        (response.MFAEnabled === false || localStorage.getItem('rememberDevice') !== 'true') &&
        TwoFAEnabled === true
      ) {
        setShouldShowLoginPage(false);
        setShouldShow2FA(true);
      } else {
        storeLogin();
      }
    }
  }, [response]);

  const Continue2Fa = () => {
    storeLogin();
  };

  const Cancel2Fa = () => {
    setShouldShow2FA(false);
    setShouldShowLoginPage(true);
  };

  function handleMsLogin({ email, accessToken }: LoginResult) {
    console.log('handleMsLogin');

    login({
      username: email,
      SSOType: 'MicrosoftEntra',
      SSOToken: accessToken,
    });
  }

  return (
    <div className={cn('loginContainerInner')}>
      <Box flx="col" ai="center">
        {shouldShow2FA && (
          <TwoFactorAuthenticationContainer
            handleContinue={Continue2Fa}
            handleCancel={Cancel2Fa}
            loginRequest={loginRequest}
          />
        )}

        {shouldShowLoginPage && (
          <Box flx="col">
            <Box mb="lg" flx="col" ai="center" height="auto">
              <SubTitle subTitle="Sign in to Online Partner Portal" />
            </Box>

            <Formik
              initialValues={{
                username: '',
                password: '',
              }}
              onSubmit={handlePartnerLogin}
            >
              {({ values, handleChange, handleBlur, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Box mb="sm" flx="col" height="auto">
                    <TextField
                      key="username"
                      name="username"
                      placeholder="Username"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.username}
                      variant="outlined"
                      elementLeft={<Icon icon="user" size="md" />}
                    />
                  </Box>

                  <Box mb="md" flx="col" height="auto">
                    <TextField
                      key="password"
                      name="password"
                      placeholder="Password"
                      preset="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.password}
                      variant="outlined"
                      elementLeft={<Icon icon="lock" size="md" />}
                    />
                  </Box>
                  <Box jc="fe" flx="col" height="auto">
                    <Button id="login-submit" type="submit" label="Login" isSubmitting={isSubmitting} />
                  </Box>
                </form>
              )}
            </Formik>

            <div className={cn('or')}>
              <hr />
              <Title level="6">or</Title>
              <hr />
            </div>

            <MSEntraButton onOpen={setUsingMsEntra} onLogin={handleMsLogin} />

            <Box mt="md" height="auto">
              <p>
                Need help logging in? Contact{' '}
                <a id="login-support-link" href="mailTo:helpdesk@vopay.com">
                  helpdesk@vopay.com
                </a>
              </p>
            </Box>
          </Box>
        )}
      </Box>

      {usingMsEntra && (
        <div className={cn('usingMsEntra')}>
          <BodyText weight="em">You are currently logging in with Microsoft in another window.</BodyText>
        </div>
      )}
    </div>
  );
};

export default LoginForm;
